import type {
  FlowV2_Action__Input,
  FlowV2_Action_Lfa__Input,
} from '~/graphql/types';
import type { ClientFlowActionLfaCreateRequest } from '~/graphql/types.client';
import removeTypenames from '~/util/removeTypenames';

/**
 *
 * @param {ClientFlowActionLfaCreateRequest} action - LFA create request client action
 */
const serializeLfaSendRequestAction = (
  action: ClientFlowActionLfaCreateRequest,
): FlowV2_Action__Input => {
  const { id, accountId, flowBlueprintId, parentIds, event } = action;

  return {
    LFA: removeTypenames<FlowV2_Action_Lfa__Input>({
      CreateRequest: {
        id,
        accountId,
        flowBlueprintId,
        parentIds,
        note: action.note,
        event,
      },
    }),
  };
};

export default serializeLfaSendRequestAction;
